import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const CancelSubscriptionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const CancelReactivateSubscriptionProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(`account/subscriptions/auto_renew`, payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      mutateAsync,
      isPending,
      error,
    }),
    [data, mutateAsync, isPending, error],
  );
  return (
    <CancelSubscriptionContext.Provider value={contextValue}>
      {children}
    </CancelSubscriptionContext.Provider>
  );
};

export default CancelReactivateSubscriptionProvider;
